import { createStyles } from '@material-ui/core/styles'
import { tokens } from '../../../assets/tokens'
import loginBackground from '../../../assets/images/velora-login-background.svg'

// Login de Velora (hrbf_freezer/src/pages/Login.jsx). Va antes de conocer al cliente,
// así que aquí la marca es siempre la de Velora.

export default theme =>
  createStyles({
    '@global': {
      body: {
        backgroundColor: theme.colors.pageBackground,
        backgroundImage: `url(${loginBackground})`,
        backgroundPosition: 'center center',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        minWidth: 320
      }
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: 470,
      maxWidth: '100%',
      boxSizing: 'border-box',
      padding: '40px 64px',
      borderRadius: 48,
      border: `solid 3px ${tokens.color.brand.primary}`,
      boxShadow: tokens.shadow.card,
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      marginBottom: 20
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: 'transparent',
      padding: 40
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1)
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
      position: 'relative'
    },
    progress: {
      color: theme.colors.greyAlpha25,
      position: 'absolute',
      right: 20
    },
    customNotchedOutline: {
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: `${tokens.color.brand.primary} !important`,
      },
    },
    customLabelFocused: {
      color: `${tokens.color.brand.primary} !important`,
    },
  })
